import { render } from "./Capacity.vue?vue&type=template&id=1d176e5a"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/healing/Capacity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d176e5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d176e5a', __exports__)) {
    api.reload('1d176e5a', __exports__)
  }
  
  module.hot.accept("./Capacity.vue?vue&type=template&id=1d176e5a", () => {
    api.rerender('1d176e5a', render)
  })

}


export default __exports__